import React from "react";
import "./App.css";

const LinksPage = () => {
  return (
    <div className="links-page">
    <div className="links-inner">
      <h2>Project Sites</h2>
      <p>No idea ever dies. Even with Fantom shutting down core infrastructure, projects will continue on.</p>
      <h3>Hubble</h3>
      <ul className="links-list">
        <li><a href="https://app.xhubble.xyz/" target="_blank" rel="noreferrer">Hubble</a></li>
        <li><a href="https://genesis.xhubble.xyz/" target="_blank" rel="noreferrer">Genesis</a></li>
        <li><a href="https://txhub.xhubble.xyz/" target="_blank" rel="noreferrer">Transferrable xHubble</a></li>
        <li><a href="https://engine.xhubble.xyz/" target="_blank" rel="noreferrer">Engine Room</a></li>
      </ul>
      <h3>Maxus' Multiverse</h3>
      <div className="note">
        <p>$ECHO, $MUNNY, and other multiverse assets were migrated to $MUNNY on Sonic.</p>
        <p>Certain things were planned to migrate to $MUNNY but it still hasn't happened.</p>
        <p>Stay tuned.</p>
      </div>
      <ul className="links-list">
        <li><a href="https://quanta.farmgod.finance/" target="_blank" rel="noreferrer">Quanta Company</a></li>
      </ul>
      <h4>1 - Deliland</h4>
      <div className="note">
        <p>$gDELI and various derivatives migrated to $DELI on Sonic.</p>
        <p>Other ERC20s, $ACRE, $SALT / $gH20 etc. converted to $LAND on Sonic.</p>
        <p>Snapshots taken in spring 2025 of various things like Land NFTs, and more.</p>
        <p>Assets reserved for future airdrop.</p>
        <p>Relaunch on Sonic pending.</p>
      </div>
      <p>The following are legacy pages, no longer working properly due to various issues.</p>
      <ul className="links-list">
        <li><a href="https://deliland.io/" target="_blank" rel="noreferrer">Deliland Mega App</a></li>
        <li><a href="https://acres.deliland.io/" target="_blank" rel="noreferrer">2021 Acres Farm</a></li>
        <li><a href="https://animalfarm.deliland.io/" target="_blank" rel="noreferrer">2021 Animal Farm</a></li>
      </ul>
      <h4>2 - Truth Universe</h4>
      <p>The following are legacy pages, no longer working properly due to various issues.</p>
      <ul className="links-list">
        <li><a href="https://eyeoftruth.io/" target="_blank" rel="noreferrer">Mythmas / Alchemists</a></li>
        <li><a href="https://you.eyeoftruth.io/" target="_blank" rel="noreferrer">Your Alchemists</a></li>
        <li><a href="https://ms2.farmgod.finance/" target="_blank" rel="noreferrer">Paradox Pub</a></li>
      </ul>
      <h4>3 - Gnosis</h4>
      <p>The following are legacy pages, no longer working properly due to various issues.</p>
      <ul className="links-list">
        <li><a href="https://moonwasp.farmgod.finance/" target="_blank" rel="noreferrer">Moonwasp</a></li>
        <li><a href="https://tequilafarm.io/" target="_blank" rel="noreferrer">Tequila Farm</a></li>
      </ul>
      <h4>Others</h4>
      <p>The following are legacy pages, no longer working properly due to various issues.</p>
      <ul className="links-list">
        <li><a href="https://moonbase.farmgod.finance/" target="_blank" rel="noreferrer">Moonbase</a></li>
        <li><a href="https://moonbasecaptains.com/" target="_blank" rel="noreferrer">Moonbase Captains</a></li>
        <li><a href="https://samlon.xyz/" target="_blank" rel="noreferrer">Samlon for Derpe Beras</a></li>
        <li><a href="https://berry.samlon.xyz/" target="_blank" rel="noreferrer">Berry Patch for Derpe Beras</a></li>
        <li><a href="https://dbkmine.com/" target="_blank" rel="noreferrer">DBK Mine</a></li>
      </ul>
      

      <h3>Cult NFTs</h3>
      <h4>Derp</h4>
      <ul className="links-list">
        <li><a href="https://derpe.xyz" target="_blank" rel="noreferrer">Derp Home</a></li>
        <li><a href="https://my.derpe.xyz" target="_blank" rel="noreferrer">Derpefier</a></li>
        <li><a href="https://derpnet.derpe.xyz" target="_blank" rel="noreferrer">Derpnet</a></li>
        <li><a href="https://shop.derpe.xyz" target="_blank" rel="noreferrer">Item Shop</a></li>
        <li><a href="https://event.derpe.xyz" target="_blank" rel="noreferrer">Derpnet</a></li>
        <li><a href="https://quest.derpe.xyz" target="_blank" rel="noreferrer">Derp Quest</a></li>
        <li><a href="https://app.quest.derpe.xyz" target="_blank" rel="noreferrer">Derp Quest App</a></li>
        <li><a href="https://beras.derpe.xyz" target="_blank" rel="noreferrer">Derpe Beras</a></li>
        <li><a href="https://uppies.xyz" target="_blank" rel="noreferrer">Uppies</a></li>
      </ul>
      <h4>Cult Game</h4>
      <div className="note">
        <p>PFPs migrated to Sonic. $CANDLE, $CULT, and $xCULT on Fantom migrated to $CANDLE on Sonic.</p>
        <p>Second promised airdrop still pending.</p>
        <p>Relaunch on Sonic pending.</p>
      </div>
      <p>The following are legacy pages, no longer working properly due to various issues.</p>
      <ul className="links-list">
        <li><a href="https://thedevilslounge.com/" target="_blank" rel="noreferrer">Cult Game on Fantom</a></li>
        <li><a href="https://forge.farmgod.finance/" target="_blank" rel="noreferrer">Forge on Fantom</a></li>
        <li><a href="https://famx.farmgod.finance/" target="_blank" rel="noreferrer">FamX on Fantom</a></li>
      </ul>


     </div>
    </div>
  );
};

export default LinksPage;
